var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 219.894,
    height: 30.716,
    viewBox: "0 0 219.894 30.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.506,
    gradientTransform: "translate(0) scale(0.978 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ffeee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fee8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#fddbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#fac496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#f7a55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48120"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3119",
    "data-name": "Group 3119",
    transform: "translate(-565 -287.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    transform: "translate(565 287.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2026",
    "data-name": "Rectangle 2026",
    d: "M4.18,0H44.713a4.181,4.181,0,0,1,4.181,4.181v22.2a4.182,4.182,0,0,1-4.182,4.182H4.18A4.18,4.18,0,0,1,0,26.378V4.18A4.18,4.18,0,0,1,4.18,0Z",
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(9.811 10.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M252.291,165.253H249.9l1.493-9.174h2.389Z",
    transform: "translate(-239.602 -155.915)",
    fill: "#0066b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M231.769,156.079l-2.277,6.31-.27-1.359h0l-.8-4.125a1.022,1.022,0,0,0-1.133-.826h-3.764l-.044.155a8.933,8.933,0,0,1,2.5,1.049l2.075,7.97h2.489l3.8-9.174Z",
    transform: "translate(-223.477 -155.915)",
    fill: "#0066b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M283.075,165.253h2.193l-1.912-9.174h-1.92a1.1,1.1,0,0,0-1.1.683l-3.562,8.49h2.49l.5-1.362H282.8Zm-2.628-3.245,1.255-3.434.706,3.434Z",
    transform: "translate(-255.996 -155.915)",
    fill: "#0066b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M266.606,158.028l.341-1.97a6.893,6.893,0,0,0-2.148-.4c-1.185,0-4,.518-4,3.037,0,2.37,3.3,2.4,3.3,3.644s-2.963,1.022-3.942.237l-.355,2.059a6.688,6.688,0,0,0,2.7.518c1.629,0,4.089-.844,4.089-3.141,0-2.385-3.334-2.608-3.334-3.645S265.584,157.465,266.606,158.028Z",
    transform: "translate(-245.645 -155.658)",
    fill: "#0066b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M229.222,161.03l-.8-4.125a1.022,1.022,0,0,0-1.133-.826h-3.764l-.044.155a9.264,9.264,0,0,1,3.545,1.779A7.15,7.15,0,0,1,229.222,161.03Z",
    transform: "translate(-223.477 -155.915)",
    fill: "#f9a533"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510",
    transform: "translate(736 287.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2027",
    "data-name": "Rectangle 2027",
    d: "M4.18,0H44.713a4.181,4.181,0,0,1,4.181,4.181v22.2a4.182,4.182,0,0,1-4.182,4.182H4.181A4.181,4.181,0,0,1,0,26.377V4.18A4.18,4.18,0,0,1,4.18,0Z",
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509",
    transform: "translate(9.837 6.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M586.417,162.877l.453-.012.446-.034.439-.055.432-.078.427-.1.418-.119.406-.138.4-.159.389-.176.378-.193.369-.211.355-.23.346-.245.332-.259.32-.277.306-.291.288-.306.277-.32.262-.331.246-.343.228-.357.211-.369.2-.378.176-.389.156-.4.138-.406.118-.418.1-.424.077-.435.055-.438.034-.447.012-.453-.012-.45-.034-.444-.055-.436-.077-.432-.1-.421-.118-.415-.138-.407-.156-.4-.176-.386-.2-.378-.211-.366-.228-.358-.246-.343-.262-.332-.277-.317-.288-.305-.306-.289-.32-.277-.332-.26-.346-.245-.355-.227-.369-.211-.378-.2-.389-.176-.4-.156-.406-.138-.418-.118-.427-.1-.432-.078-.439-.055-.446-.034-.453-.012-.453.012-.447.034-.438.055-.433.078-.427.1-.415.118-.409.138-.4.156-.389.176-.378.2-.366.211-.357.227-.343.245-.332.26-.317.277-.3.289-.291.305-.277.317-.259.332-.245.343-.228.358-.211.366-.194.378-.173.386-.159.4-.139.407-.115.415-.1.421-.078.432-.055.436-.035.444-.011.45.011.453.035.447.055.438.078.435.1.424.115.418.139.406.159.4.173.389.194.378.211.369.228.357.245.343.259.331.277.32.291.306.3.291.317.277.332.259.343.245.357.23.366.211.378.193.389.176.4.159.409.138.415.119.427.1.433.078.438.055.447.034Z",
    transform: "translate(-565.988 -145.326)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M556.531,162.877l.453-.012.447-.034.438-.055.433-.078.427-.1.416-.119.409-.138.4-.159.39-.176.377-.193.366-.211.358-.23.343-.245.332-.259.318-.277.305-.291.289-.306.277-.32.259-.331.245-.343.228-.357.211-.369.193-.378.176-.389.156-.4.138-.406.116-.418.1-.424.078-.435.055-.438.034-.447.012-.453-.012-.45-.034-.444-.055-.436-.078-.432-.1-.421-.116-.415-.138-.407-.156-.4-.176-.386-.193-.378-.211-.366-.228-.358-.245-.343-.259-.332-.277-.317-.289-.305-.305-.289-.318-.277-.332-.26-.343-.245-.358-.227-.366-.211-.377-.2-.39-.176-.4-.156-.409-.138-.416-.118-.427-.1-.433-.078-.438-.055-.447-.034-.453-.012-.453.012-.447.034-.438.055-.433.078-.427.1-.419.118-.407.138-.4.156-.389.176-.378.2-.369.211-.355.227-.346.245-.331.26-.32.277-.3.289-.291.305-.277.317-.262.332-.245.343-.228.358-.211.366-.2.378-.176.386-.156.4-.138.407-.118.415-.1.421-.077.432-.055.436-.035.444-.011.45.011.453.035.447.055.438.077.435.1.424.118.418.138.406.156.4.176.389.2.378.211.369.228.357.245.343.262.331.277.32.291.306.3.291.32.277.331.259.346.245.355.23.369.211.378.193.389.176.4.159.407.138.419.119.427.1.433.078.438.055.447.034Z",
    transform: "translate(-547.741 -145.326)",
    fill: "#0084c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M582.446,153.133h4.45v-.49h-4.02Z",
    transform: "translate(-568.918 -149.79)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M580.655,155.8H585.8v-.487h-4.836Z",
    transform: "translate(-567.825 -151.42)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M579.315,158.5h5.67v-.49h-5.43Z",
    transform: "translate(-567.007 -153.067)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M578.444,161.171h6.01v-.488h-5.86Z",
    transform: "translate(-566.476 -154.697)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M577.873,163.837h6.232v-.49h-6.143Z",
    transform: "translate(-566.128 -156.322)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M577.688,169.008h6.278v-.491h-6.321Z",
    transform: "translate(-565.988 -159.477)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M578,171.828h6.128v-.49H577.91Z",
    transform: "translate(-566.15 -161.198)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M578.667,174.114H584.5v-.49h-5.981Z",
    transform: "translate(-566.52 -162.593)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M579.671,176.9h5.387v-.49h-5.623Z",
    transform: "translate(-567.08 -164.29)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M581.132,179.714h4.761v-.49H580.8Z",
    transform: "translate(-567.915 -166.01)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M582.986,182.421h3.934v-.49h-4.363Z",
    transform: "translate(-568.985 -167.662)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(27.766 13.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M618.992,181.088l.026-.078.043-.072.055-.063.064-.052.072-.04.078-.026.084-.009.086.009.081.026.072.04.064.052.052.063.04.072.026.078h-.089l-.018-.055-.031-.061-.041-.052-.049-.041-.058-.031-.066-.02-.069-.006-.069.006-.067.02-.057.031-.051.041-.041.052-.031.061-.017.055Z",
    transform: "translate(-618.983 -180.748)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M619.688,181.458v-.1h.164l.037,0,.031,0,.029.009.023.011.018.014.014.017.009.02,0,.026h-.075l0-.014-.006-.012-.009-.011-.011-.009-.014-.006-.014,0-.015,0h-.107v.058Z",
    transform: "translate(-619.408 -181.118)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M618.977,181.7l.006-.072v0h.087l0,.014-.006.061Z",
    transform: "translate(-618.974 -181.281)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M619.688,181.7v-.075h.075v.06h.124l.017,0,.015-.006.009-.006.009-.011.006-.014v-.02h.075l0,.026-.006.023-.008.017-.009.009Z",
    transform: "translate(-619.408 -181.281)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M620.931,181.7l-.005-.061,0-.014h.089v0l.008.072Z",
    transform: "translate(-620.162 -181.281)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M618.973,181.813l0,.014.008.087L619,182l.043.069.055.063.064.049.072.038.078.023.084.009.086-.009.081-.023.072-.038.064-.049.052-.063.04-.069.026-.081.009-.087v-.014h-.09v.014l-.005.075-.021.069-.031.061-.041.052-.049.043-.058.032-.066.02-.069.006-.069-.006-.067-.02-.057-.032-.051-.043-.041-.052-.031-.061-.02-.069-.006-.075v-.014Z",
    transform: "translate(-618.97 -181.398)",
    fill: "#ec1c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M619.688,181.813v.179h.075v-.147h.075l.089.147H620l-.107-.147.026,0,.026,0,.021-.008.017-.011.006-.006Z",
    transform: "translate(-619.408 -181.398)",
    fill: "#ec1c2e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M589.834,164.3l-.057,0-.057-.006-.052-.009-.051,0-.052-.009-.052-.009-.055-.009-.058-.009-.06-.006-.064-.005-.072-.006-.078,0h-.086l-.1,0-.107.006-.115.009-.084.012-.078.017-.072.023-.064.026-.058.031-.052.035-.044.04-.034.04-.026.046-.017.049-.009.049v.052l.012.055.02.055.031.055.04.055.084.075.1.061.116.052.124.043.13.043.136.043.138.049.133.058.124.069.118.084.1.107.087.127.066.156.043.185.015.219-.015.26-.032.193-.052.173-.066.156-.084.138-.1.121-.107.1-.118.089-.126.078-.133.063-.138.052-.142.044-.141.031-.141.023-.139.014-.132.009-.13,0h-.179l-.161,0-.147,0-.135,0-.124-.006-.11-.006-.1-.008-.093-.012-.086-.012-.081-.014-.075-.014-.074-.02-.069-.02-.069-.02-.069-.026-.072-.026.179-.905.041.009.049.014.06.014.067.017.078.015.087.02.092.017.1.017.1.015.11.014.113.012.118.011.118.006.121,0h.121l.124-.006.115-.02.095-.032.072-.046.057-.052.044-.061.032-.063.026-.064.017-.063.009-.066,0-.058-.014-.055-.024-.046-.031-.046-.04-.04-.049-.038-.055-.035-.061-.031-.066-.032L588.09,166l-.076-.029-.075-.029-.08-.032-.081-.032-.084-.034-.081-.035-.08-.038-.081-.043-.078-.046-.075-.049-.07-.055-.066-.063-.06-.066-.055-.075-.049-.081-.04-.089-.034-.1L586.9,165l-.014-.115,0-.127.009-.136.008-.084.012-.081.012-.077.017-.075.017-.073.02-.072.026-.066.026-.066.031-.061.032-.06.038-.055.041-.055.043-.052.046-.049.049-.046.055-.043.058-.04.061-.038.066-.034.07-.035.071-.029.078-.029.081-.023.086-.023.093-.02.1-.017.1-.014.1-.012.109-.009.115-.005.119-.006h.276l.139,0,.124,0,.115.005.1.006.093.006.083.009.072.006.067.009.057.009.055.005.046.009.041.006.037.006.034.006.032,0Z",
    transform: "translate(-571.306 -156.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(15.054 6.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M589.834,164.3h0l-.057,0-.057-.006-.052-.009-.051,0-.052-.009-.052-.009-.055-.009-.058-.009-.06-.006-.064-.005-.072-.006-.078,0h-.086l-.1,0-.107.006-.115.009h0l-.084.012-.078.017-.072.023-.064.026-.058.031-.052.035-.044.04-.034.04-.026.046-.017.049-.009.049v.052l.012.055.02.055.031.055.04.055h0l.084.075.1.061.116.052.124.043.13.043.136.043.138.049.133.058.124.069.118.084.1.107.087.127.066.156.043.185.015.219-.015.26h0l-.032.193-.052.173-.066.156-.084.138-.1.121-.107.1-.118.089-.126.078-.133.063-.138.052-.142.044-.141.031-.141.023-.139.014-.132.009-.13,0h-.179l-.161,0-.147,0-.135,0-.124-.006-.11-.006-.1-.008-.093-.012-.086-.012-.081-.014-.075-.014-.074-.02-.069-.02-.069-.02-.069-.026-.072-.026.179-.905h0l.041.009.049.014.06.014.067.017.078.015.087.02.092.017.1.017.1.015.11.014.113.012.118.011.118.006.121,0h.121l.124-.006h0l.115-.02.095-.032.072-.046.057-.052.044-.061.032-.063.026-.064.017-.063h0l.009-.066,0-.058-.014-.055-.024-.046-.031-.046-.04-.04-.049-.038-.055-.035-.061-.031-.066-.032L588.09,166l-.076-.029-.075-.029-.08-.032-.081-.032-.084-.034-.081-.035-.08-.038-.081-.043-.078-.046-.075-.049-.07-.055-.066-.063-.06-.066-.055-.075-.049-.081-.04-.089-.034-.1L586.9,165l-.014-.115,0-.127.009-.136h0l.008-.084.012-.081.012-.077.017-.075.017-.073.02-.072.026-.066.026-.066.031-.061.032-.06.038-.055.041-.055.043-.052.046-.049.049-.046.055-.043.058-.04.061-.038.066-.034.07-.035.071-.029.078-.029.081-.023.086-.023.093-.02.1-.017.1-.014.1-.012.109-.009.115-.005.119-.006h.276l.139,0,.124,0,.115.005.1.006.093.006.083.009.072.006.067.009.057.009.055.005.046.009.041.006.037.006.034.006.032,0-.208.934",
    transform: "translate(-586.359 -163.274)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M596.461,160.95h1.159l-.179,1.01h.712l-.162.92-.729-.015-.384,2.3-.006.049v.043l.006.038.012.035.017.029.02.029.026.023.029.017.035.018.035.014.04.012.041.006.046.009.046,0,.049,0h.141l.081-.006.075-.012.064-.015.049-.014.038-.015.023-.012.009,0-.118.787-.029.017-.032.015-.032.014-.032.014-.031.011-.035.011-.034.011-.04.012-.041.011-.043.009-.049.009-.052.009-.055.009-.057.009-.066.009-.069.009h-.312l-.164-.012-.147-.017-.13-.024-.113-.032-.1-.034-.081-.043-.066-.049-.055-.055-.044-.061-.032-.066-.02-.072-.011-.08,0-.084,0-.092.008-.1.015-.1Z",
    transform: "translate(-576.984 -154.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(18.681 6.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M596.461,160.95h1.159l-.179,1.01h.712l-.162.92-.729-.015-.384,2.3h0l-.006.049v.043l.006.038.012.035.017.029.02.029.026.023.029.017.035.018.035.014.04.012.041.006.046.009.046,0,.049,0h.141l.081-.006.075-.012.064-.015.049-.014.038-.015.023-.012.009,0-.118.787h0l-.029.017-.032.015-.032.014-.032.014-.031.011-.035.011-.034.011-.04.012-.041.011-.043.009-.049.009-.052.009-.055.009-.057.009-.066.009-.069.009h-.312l-.164-.012-.147-.017-.13-.024-.113-.032-.1-.034-.081-.043-.066-.049-.055-.055-.044-.061-.032-.066-.02-.072-.011-.08,0-.084,0-.092.008-.1.015-.1.77-4.51",
    transform: "translate(-595.665 -160.95)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M577.713,165.891l-.015.072,0,.072.006.078.017.075.023.078.035.078.04.075.049.072.055.069.064.067.066.057.072.055.077.046.081.038.087.029.086.02.1.015.1.014.107.012.107.006.11,0h.107l.113-.005.109-.009.112-.017.115-.02.115-.029.115-.037.115-.043.121-.052.118-.063.121-.069-.179,1.024-.067.035-.066.032-.06.026-.063.023-.064.023-.064.017-.066.015-.072.015-.074.009-.081.008-.089.009-.095,0-.1.005h-.116l-.127,0h-.239l-.1-.006-.1-.006-.1-.011-.107-.014-.1-.018-.1-.023-.1-.023-.1-.032-.1-.032-.1-.038-.1-.043-.095-.049-.093-.052-.086-.057-.087-.063-.081-.069-.078-.075-.075-.081-.066-.087-.063-.1-.057-.1-.052-.106-.046-.113-.041-.12-.032-.127-.026-.133-.017-.144-.011-.15V165.8l.005-.167.014-.174.009-.06.009-.069.012-.069.014-.075.014-.078.02-.081.023-.084.023-.086.029-.09.031-.086.038-.089.04-.089.046-.09.049-.089.055-.089.057-.087.067-.084.069-.084.075-.081.084-.075.086-.075.1-.069.1-.064.11-.061.115-.052.124-.049.129-.043.138-.035.147-.029.156-.02.162-.012.173-.006h.081l.081.006.084.006.084.009.083.012.087.017.084.02.084.023.083.025.084.032.081.034.078.041.075.046.075.049.069.058.07.06.063.066.061.072.055.081.049.084.047.092.04.1.034.107.026.113.023.121.014.126.006.136v.144l-.009.153-.014.161-.026.171-.035.179-.046.254h-3l.178-.8h1.8l.009-.11v-.1l-.006-.1-.017-.087-.023-.077-.029-.072-.037-.064-.043-.058-.049-.052-.055-.043-.058-.035-.061-.029-.066-.023-.069-.018-.072-.008-.075,0h-.081l-.075.011-.075.014-.069.024-.066.032-.063.037-.061.043-.055.049-.052.058-.046.061-.044.066-.04.072-.034.075-.029.081-.023.087-.021.089Z",
    transform: "translate(-565.284 -156.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(11.207 7.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M577.713,165.891h0l-.015.072,0,.072.006.078.017.075.023.078.035.078.04.075.049.072.055.069.064.067.066.057.072.055.077.046.081.038.087.029.086.02h0l.1.015.1.014.107.012.107.006.11,0h.107l.113-.005.109-.009.112-.017.115-.02.115-.029.115-.037.115-.043.121-.052.118-.063.121-.069-.179,1.024h0l-.067.035-.066.032-.06.026-.063.023-.064.023-.064.017-.066.015-.072.015-.074.009-.081.008-.089.009-.095,0-.1.005h-.116l-.127,0h-.239l-.1-.006-.1-.006-.1-.011-.107-.014-.1-.018-.1-.023-.1-.023-.1-.032-.1-.032-.1-.038-.1-.043-.095-.049-.093-.052-.086-.057-.087-.063-.081-.069-.078-.075-.075-.081-.066-.087-.063-.1-.057-.1-.052-.106-.046-.113-.041-.12-.032-.127-.026-.133-.017-.144-.011-.15V165.8l.005-.167.014-.174h0l.009-.06.009-.069.012-.069.014-.075.014-.078.02-.081.023-.084.023-.086.029-.09.031-.086.038-.089.04-.089.046-.09.049-.089.055-.089.057-.087.067-.084.069-.084.075-.081.084-.075.086-.075.1-.069.1-.064.11-.061.115-.052.124-.049.129-.043.138-.035.147-.029.156-.02.162-.012.173-.006h.081l.081.006.084.006.084.009.083.012.087.017.084.02.084.023.083.025.084.032.081.034.078.041.075.046.075.049.069.058.07.06.063.066.061.072.055.081.049.084.047.092.04.1.034.107.026.113.023.121.014.126.006.136v.144l-.009.153-.014.161-.026.171-.035.179-.046.254h-3l.178-.8h1.8l.009-.11v-.1l-.006-.1-.017-.087-.023-.077-.029-.072-.037-.064-.043-.058-.049-.052-.055-.043-.058-.035-.061-.029-.066-.023-.069-.018-.072-.008-.075,0h-.081l-.075.011-.075.014-.069.024-.066.032-.063.037-.061.043-.055.049-.052.058-.046.061-.044.066-.04.072-.034.075-.029.081-.023.087-.021.089-.161.862",
    transform: "translate(-576.491 -163.31)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M569.631,166.937l-.165.92h-1.041l.012-.087.011-.087.012-.077.011-.072.012-.061.009-.052.011-.035.012-.02-.055.063-.069.063-.077.061-.09.057-.095.055-.1.052-.11.046-.113.043-.118.038-.121.032-.121.022-.121.018-.121.009-.118,0-.115-.008-.113-.018-.147-.034-.13-.046-.118-.055-.1-.061-.092-.066-.079-.075-.069-.078-.058-.086-.049-.087-.04-.09-.032-.093-.026-.095-.017-.092-.012-.1-.005-.092,0-.09.012-.161.026-.153.038-.148.054-.138.066-.129.075-.121.09-.113.1-.107.107-.1.112-.083.121-.078.127-.067.132-.057.136-.047.138-.034.141-.026h.006l.02,0,.032,0,.043-.006.049-.005.057-.006.064-.009.069-.005.069-.006.07-.009.072-.006.069-.006.063-.006.061,0,.055,0h.193l.052,0h.049l.046,0h.092l.04,0h.038l.032,0h.029l.023,0h.032l.009-.029.02-.069.015-.081V164.8l-.006-.052-.009-.049-.014-.046-.02-.043-.023-.04-.029-.037-.029-.035-.035-.035-.037-.029-.038-.023-.044-.023-.043-.02-.046-.014-.049-.012-.049-.008-.049-.006-.118,0-.124,0-.13,0-.132.009-.133.009-.133.011-.133.015-.13.014-.124.02-.118.017-.107.021-.1.023-.09.023-.075.023-.061.023-.042.026.3-.98.087-.04.093-.038.092-.032.1-.026.1-.02.1-.017.11-.014.112-.011.116-.006.118-.006.121,0h.392l.139,0,.144,0,.118.011.124.017.129.032.13.037.13.049.13.061.121.069.115.081.107.092.1.1.081.113.063.124.046.136.026.147,0,.155-.023.17Z",
    transform: "translate(-558.805 -156.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(7.068 7.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M569.631,166.937l-.165.92h-1.041l.012-.087.011-.087.012-.077.011-.072.012-.061.009-.052.011-.035.012-.02h0l-.055.063-.069.063-.077.061-.09.057-.095.055-.1.052-.11.046-.113.043-.118.038-.121.032-.121.022-.121.018-.121.009-.118,0-.115-.008-.113-.018h0l-.147-.034-.13-.046-.118-.055-.1-.061-.092-.066-.079-.075-.069-.078-.058-.086-.049-.087-.04-.09-.032-.093-.026-.095-.017-.092-.012-.1-.005-.092,0-.09h0l.012-.161.026-.153.038-.148.054-.138.066-.129.075-.121.09-.113.1-.107.107-.1.112-.083.121-.078.127-.067.132-.057.136-.047.138-.034.141-.026h.006l.02,0,.032,0,.043-.006.049-.005.057-.006.064-.009.069-.005.069-.006.07-.009.072-.006.069-.006.063-.006.061,0,.055,0h.193l.052,0h.049l.046,0h.092l.04,0h.038l.032,0h.029l.023,0h.032l.009-.029.02-.069.015-.081V164.8h0l-.006-.052-.009-.049-.014-.046-.02-.043-.023-.04-.029-.037-.029-.035-.035-.035-.037-.029-.038-.023-.044-.023-.043-.02-.046-.014-.049-.012-.049-.008-.049-.006h0l-.118,0-.124,0-.13,0-.132.009-.133.009-.133.011-.133.015-.13.014-.124.02-.118.017-.107.021-.1.023-.09.023-.075.023-.061.023-.042.026.3-.98h0l.087-.04.093-.038.092-.032.1-.026.1-.02.1-.017.11-.014.112-.011.116-.006.118-.006.121,0h.392l.139,0,.144,0h0l.118.011.124.017.129.032.13.037.13.049.13.061.121.069.115.081.107.092.1.1.081.113.063.124.046.136.026.147,0,.155-.023.17-.43,2.166",
    transform: "translate(-565.873 -163.37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M570.65,169.626l0-.023-.017-.017-.029-.014-.037-.008-.049-.006-.052,0h-.124l-.066.006-.069.009-.066.009-.066.012-.064.011-.061.012-.051.014-.046.015-.026.006-.035.011-.043.015-.047.02-.049.021-.055.026-.055.031-.054.032-.055.04-.052.044-.049.046-.043.053-.041.054-.029.061-.023.066-.015.069-.005.141.02.11.034.086.052.064.064.043.066.029.072.015.069,0,.127,0,.113-.012.106-.02.1-.026.087-.029.078-.034.069-.04.061-.043.055-.043.046-.049.041-.046.034-.049.029-.049.023-.047.018-.046.014-.043.015-.064.014-.066.014-.069.015-.072.011-.069.012-.064.011-.061Z",
    transform: "translate(-560.819 -160.11)",
    fill: "#0084c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M551.421,166.381h-1.128l.949-5.431H553.2l.193,3.233,1.335-3.233h2.036l-.951,5.431h-1.128l.712-4.067h-.043l-1.678,4.067h-1.263l-.012-.171-.026-.453-.037-.641-.043-.735-.043-.742-.037-.654-.026-.473-.011-.2h-.046Z",
    transform: "translate(-549.298 -154.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(0.995 6.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M551.421,166.381h-1.128l.949-5.431H553.2l.193,3.233,1.335-3.233h2.036l-.951,5.431h-1.128l.712-4.067h-.043l-1.678,4.067h-1.263l-.012-.171-.026-.453-.037-.641-.043-.735-.043-.742-.037-.654-.026-.473-.011-.2h-.046l-.712,4.067",
    transform: "translate(-550.292 -160.95)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M601.519,167.866h1.174l.4-2.345.017-.092.02-.089.023-.089.029-.084.032-.084.041-.078.049-.075.055-.072.067-.064.074-.058.09-.052.1-.046.116-.037.13-.029.144-.017.161-.012h.014l.017,0,.023,0h.023l.02,0,.017,0,.012,0h.006l0-.017.012-.05.015-.075.023-.095.029-.106.031-.116.038-.115.043-.109.032-.081.038-.078.037-.078.041-.072.035-.061.029-.049.02-.032.006-.011h-.006l-.015-.006-.02,0-.029-.006-.029-.006-.035,0-.031-.006h-.029l-.127.009-.115.014-.107.023-.1.026-.092.034-.083.038-.081.046-.072.049-.072.055-.066.06-.061.063-.064.069-.06.072-.058.078-.061.081-.06.084.135-.741-1.174-.015-.773,4.436Z",
    transform: "translate(-580.556 -156.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(20.963 7.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M601.519,167.866h1.174l.4-2.345h0l.017-.092.02-.089.023-.089.029-.084.032-.084.041-.078.049-.075.055-.072.067-.064.074-.058.09-.052.1-.046.116-.037.13-.029.144-.017.161-.012h.014l.017,0,.023,0h.023l.02,0,.017,0,.012,0h.006l0-.017.012-.05.015-.075.023-.095.029-.106.031-.116.038-.115.043-.109h0l.032-.081.038-.078.037-.078.041-.072.035-.061.029-.049.02-.032.006-.011h-.006l-.015-.006-.02,0-.029-.006-.029-.006-.035,0-.031-.006h-.029l-.127.009-.115.014-.107.023-.1.026-.092.034-.083.038-.081.046-.072.049-.072.055-.066.06-.061.063-.064.069-.06.072-.058.078-.061.081-.06.084.135-.741-1.174-.015-.773,4.436h0",
    transform: "translate(-601.519 -163.385)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M610.822,163.385l.13,0,.127.009.124.011.122.017.115.023.112.029.107.032.106.037.1.043.1.046.1.049.087.055.087.06.08.063.075.067.072.072.069.075.063.081.058.081.054.086.052.089.043.1.043.1.035.1.032.1.026.107.023.11.018.112.011.112.006.119,0,.121,0,.121-.009.147-.017.142-.02.135-.026.132-.029.127-.037.121-.04.119-.043.112-.052.107-.051.1-.061.1-.06.092-.066.09-.072.083-.075.078-.078.075-.081.069-.084.067-.089.06-.09.055-.1.052-.1.046-.1.043-.1.037-.1.034-.11.029-.11.023-.11.02-.115.014-.115.011-.118.006-.118,0-.118,0-.118-.006-.112-.011-.113-.018-.109-.02-.11-.023-.1-.029-.1-.034-.1-.037-.1-.044-.092-.046-.09-.052-.086-.054-.081-.061-.081-.063-.075-.069-.069-.072-.069-.078-.061-.08-.06-.087-.052-.089-.052-.095-.043-.1-.041-.1-.034-.107-.032-.112-.026-.115-.02-.119-.014-.123-.009-.127,0-.132,0-.135.009-.138.014-.133.02-.13.026-.124.029-.121.034-.118.037-.112.043-.109.046-.107.051-.1.058-.1.061-.1.064-.086.069-.087.072-.078.075-.078.081-.072.084-.066.086-.063.09-.058.095-.052.1-.052.1-.043.1-.041L610,163.5l.109-.032.113-.026.115-.023.118-.015.121-.014.124-.006Z",
    transform: "translate(-584.781 -156.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    transform: "translate(23.662 7.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M610.822,163.385h0l.13,0,.127.009.124.011.122.017.115.023.112.029.107.032.106.037.1.043.1.046.1.049.087.055.087.06.08.063.075.067.072.072.069.075.063.081.058.081.054.086.052.089.043.1.043.1.035.1.032.1.026.107.023.11.018.112.011.112.006.119,0,.121,0,.121h0l-.009.147-.017.142-.02.135-.026.132-.029.127-.037.121-.04.119-.043.112-.052.107-.051.1-.061.1-.06.092-.066.09-.072.083-.075.078-.078.075-.081.069-.084.067-.089.06-.09.055-.1.052-.1.046-.1.043-.1.037-.1.034-.11.029-.11.023-.11.02-.115.014-.115.011-.118.006-.118,0h0l-.118,0-.118-.006-.112-.011-.113-.018-.109-.02-.11-.023-.1-.029-.1-.034-.1-.037-.1-.044-.092-.046-.09-.052-.086-.054-.081-.061-.081-.063-.075-.069-.069-.072-.069-.078-.061-.08-.06-.087-.052-.089-.052-.095-.043-.1-.041-.1-.034-.107-.032-.112-.026-.115-.02-.119-.014-.123-.009-.127,0-.132,0-.135h0l.009-.138.014-.133.02-.13.026-.124.029-.121.034-.118.037-.112.043-.109.046-.107.051-.1.058-.1.061-.1.064-.086.069-.087.072-.078.075-.078.081-.072.084-.066.086-.063.09-.058.095-.052.1-.052.1-.043.1-.041L610,163.5l.109-.032.113-.026.115-.023.118-.015.121-.014.124-.006.124,0",
    transform: "translate(-608.443 -163.385)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M618.97,174.311h.34v.043h-.133v.282H619.1v-.282h-.133Z",
    transform: "translate(-591.204 -163.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(27.766 11.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M618.97,174.311h.34v.043h-.133v.282H619.1v-.282h-.133v-.043",
    transform: "translate(-618.97 -174.311)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M619.954,174.311h.1l.121.251h0l.118-.251h.1v.326h-.075v-.25h0l-.118.25h-.06l-.119-.25h0v.25h-.074Z",
    transform: "translate(-591.805 -163.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(28.149 11.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M619.954,174.311h.1l.121.251h0l.118-.251h.1v.326h-.075v-.25h0l-.118.25h-.06l-.119-.25h0v.25h-.074v-.326",
    transform: "translate(-619.954 -174.311)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.215
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M612.145,167.039l-.017.162-.009.15v.136l.009.127.017.116.025.1.033.092.04.083.049.072.055.061.061.052.067.041.072.031.081.023.083.011.09.006.1,0,.1-.011.089-.021.086-.031.081-.041.077-.052.072-.061.069-.072.061-.08.058-.093.055-.1.046-.112.043-.124.037-.135.029-.147.026-.158.014-.124.009-.118V166.7l-.009-.109-.014-.1-.023-.1-.032-.089-.037-.083-.046-.075-.052-.064-.06-.058-.066-.046-.075-.038-.081-.023-.086-.014h-.1l-.118.009-.11.02-.1.034-.1.044-.086.058-.081.064-.072.072-.064.081-.06.086-.052.092-.047.092-.037.1-.034.1-.029.1-.02.1Z",
    transform: "translate(-587.023 -157.88)",
    fill: "#ec1c2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(622 287.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2028",
    "data-name": "Rectangle 2028",
    d: "M4.181,0H44.713a4.181,4.181,0,0,1,4.181,4.181v22.2a4.182,4.182,0,0,1-4.182,4.182H4.181A4.181,4.181,0,0,1,0,26.377V4.181A4.181,4.181,0,0,1,4.181,0Z",
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(9.791 6.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M424.675,162.879l.452-.012.447-.033.438-.056.435-.077.423-.1.418-.118.408-.139.4-.157.39-.177.379-.192.367-.213.358-.228.343-.245.331-.261.32-.275.3-.293.293-.305.275-.32.261-.331.245-.343.228-.358.212-.368.192-.379.178-.39.157-.4.139-.408.119-.417.1-.423.077-.435.056-.438.033-.447.011-.453-.011-.45-.033-.444-.056-.438-.077-.429-.1-.423-.119-.415-.139-.408-.157-.4-.178-.387-.192-.379-.212-.364-.228-.358-.245-.343-.261-.328-.275-.319-.293-.305-.3-.29-.32-.275-.331-.261-.343-.245-.358-.228-.367-.21-.379-.192-.39-.178-.4-.157-.408-.139-.418-.118-.423-.1-.435-.077-.438-.056-.447-.033-.452-.012-.45.012-.447.033-.437.056-.432.077-.423.1-.417.118-.406.139-.4.157-.388.178-.376.192-.367.21-.355.228-.343.245-.332.261-.317.275-.305.29-.29.305-.275.319-.26.328-.242.343-.228.358-.21.364-.2.379-.175.387-.157.4-.136.408-.119.415-.1.423-.077.429-.056.438-.033.444-.012.45.012.453.033.447.056.438.077.435.1.423.119.417.136.408.157.4.175.39.2.379.21.368.228.358.242.343.26.331.275.32.29.305.305.293.317.275.332.261.343.245.355.228.367.213.376.192.388.177.4.157.406.139.417.118.423.1.432.077.437.056.447.033.45.012Z",
    transform: "translate(-404.151 -145.335)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M394.519,162.879l.449-.012.447-.033.438-.056.432-.077.423-.1.417-.118.406-.139.4-.157.388-.177.376-.192.367-.213.355-.228.344-.245.331-.261.316-.275.3-.293L401,160l.275-.32.26-.331.242-.343.228-.358.21-.368.2-.379.174-.39.157-.4.136-.408.118-.417.1-.423.077-.435.056-.438.032-.447.012-.453-.012-.45-.032-.444-.056-.438-.077-.429-.1-.423-.118-.415-.136-.408-.157-.4-.174-.387-.2-.379-.21-.364-.228-.358-.242-.343-.26-.328-.275-.319-.29-.305-.3-.29-.316-.275-.331-.261-.344-.245-.355-.228-.367-.21-.376-.192-.388-.178-.4-.157-.406-.139-.417-.118-.423-.1-.432-.077-.438-.056-.447-.033-.449-.012-.453.012-.447.033-.438.056-.435.077-.423.1-.417.118-.408.139-.4.157-.391.178-.379.192-.367.21-.358.228-.343.245-.331.261-.32.275-.3.29-.293.305-.275.319-.26.328-.246.343-.228.358-.213.364-.192.379-.178.387-.157.4-.139.408-.118.415-.1.423-.077.429-.056.438-.033.444-.012.45.012.453.033.447.056.438.077.435.1.423.118.417.139.408.157.4.178.39.192.379.213.368.228.358.246.343.26.331.275.32.293.305.3.293.32.275.331.261.343.245.358.228.367.213.379.192.391.177.4.157.408.139.417.118.423.1.435.077.438.056.447.033.453.012Z",
    transform: "translate(-385.731 -145.335)",
    fill: "#ec1c2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M420.695,153.221h4.66v-.477H421.1l-.4.477Z",
    transform: "translate(-407.066 -149.856)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M418.9,155.938h5.359v-.477h-5.078l-.281.477Z",
    transform: "translate(-405.972 -151.514)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M417.567,158.648h5.879v-.477h-5.672l-.207.477Z",
    transform: "translate(-405.157 -153.168)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M416.648,161.366h6.238v-.476H416.8l-.148.476Z",
    transform: "translate(-404.596 -154.826)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M416.948,174.5h6.045v-.476H416.8l.148.476Z",
    transform: "translate(-404.689 -162.839)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M417.978,177.215h5.6v-.476h-5.82l.222.476Z",
    transform: "translate(-405.272 -164.497)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M419.467,179.925h4.971v-.476h-5.27l.3.476Z",
    transform: "translate(-406.134 -166.151)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M421.5,182.638h4.107v-.479h-4.524l.417.479Z",
    transform: "translate(-407.302 -167.804)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M416.11,164.076h6.447V163.6H416.2l-.092.476Z",
    transform: "translate(-404.268 -156.48)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M426.189,171.788h2.459v-.477h-2.37l-.089.477Z",
    transform: "translate(-410.418 -161.185)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M426.691,169.073h2.263v-.479H426.78l-.089.479Z",
    transform: "translate(-410.725 -159.527)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M415.692,168.594h.639v.479h-.61l-.03-.479Z",
    transform: "translate(-404.013 -159.527)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M408.742,165.946l-.041,0-.041-.006-.039-.006-.038-.006-.036-.006-.038-.006-.038-.006-.042-.006-.041-.005-.047,0-.053,0-.056,0h-.062l-.068,0-.077.006-.086.005-.059.009-.056.009-.051.018-.044.018-.042.021-.038.024-.03.03-.027.026-.017.033-.015.033-.006.035v.036l.009.039.012.038.023.039.03.038.059.056.072.045.082.038.089.033.095.03.1.033.1.036.095.038.089.05.083.062.074.074.062.092.047.112.03.133.011.16-.011.186-.021.139-.036.121-.048.112-.059.1-.068.086-.077.074-.083.065-.091.057-.1.044-.1.038-.1.03-.1.024-.1.018-.1.009-.1.006-.092,0H407.3l-.118,0h-.1l-.1,0-.089,0-.08-.006-.071-.006-.068-.009-.062-.006-.056-.012-.056-.009-.05-.014-.051-.012-.047-.018-.048-.017-.05-.018.133-.654.027.006.032.009.042.011.051.012.053.012.059.012.065.015.071.012.074.012.077.012.08.009.083.009.085,0,.087,0h.085l.086,0,.086-.018.068-.024.053-.032.042-.041.029-.042.024-.048.015-.047.011-.044.007-.086-.027-.074-.051-.059-.074-.05-.089-.044-.1-.045-.115-.042-.115-.047-.118-.053-.112-.062-.1-.077-.1-.092-.074-.113-.053-.133-.027-.159,0-.189.015-.116.021-.11.029-.1.035-.095.047-.089.053-.077.062-.074.074-.065.086-.056.094-.048.106-.044.118-.033.134-.027.145-.021.159-.012.175,0h.109l.1,0,.092,0,.083,0,.074.006.068.006.059.006.053.006.05.006.042.009.038.006.036.006.029.006.026,0,.026.006.024,0-.151.668Z",
    transform: "translate(-398.255 -157.457)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M408.742,165.946h0l-.041,0-.041-.006-.039-.006-.038-.006-.036-.006-.038-.006-.038-.006-.042-.006-.041-.005-.047,0-.053,0-.056,0h-.062l-.068,0-.077.006-.086.005h0l-.059.009-.056.009-.051.018-.044.018-.042.021-.038.024-.03.03-.027.026-.017.033-.015.033-.006.035v.036l.009.039.012.038.023.039.03.038h0l.059.056.072.045.082.038.089.033.095.03.1.033.1.036.095.038.089.05.083.062.074.074.062.092.047.112.03.133.011.16-.011.186h0l-.021.139-.036.121-.048.112-.059.1-.068.086-.077.074-.083.065-.091.057-.1.044-.1.038-.1.03-.1.024-.1.018-.1.009-.1.006-.092,0H407.3l-.118,0h-.1l-.1,0-.089,0-.08-.006-.071-.006-.068-.009-.062-.006-.056-.012-.056-.009-.05-.014-.051-.012-.047-.018-.048-.017-.05-.018.133-.654h0l.027.006.032.009.042.011.051.012.053.012.059.012.065.015.071.012.074.012.077.012.08.009.083.009.085,0,.087,0h.085l.086,0h0l.086-.018.068-.024.053-.032.042-.041.029-.042.024-.048.015-.047.011-.044h0l.007-.086-.027-.074-.051-.059-.074-.05-.089-.044-.1-.045-.115-.042-.115-.047-.118-.053-.112-.062-.1-.077-.1-.092-.074-.113-.053-.133-.027-.159,0-.189h0l.015-.116.021-.11.029-.1.035-.095.047-.089.053-.077.062-.074.074-.065.086-.056.094-.048.106-.044.118-.033.134-.027.145-.021.159-.012.175,0h.109l.1,0,.092,0,.083,0,.074.006.068.006.059.006.053.006.05.006.042.009.038.006.036.006.029.006.026,0,.026.006.024,0-.151.668",
    transform: "translate(-398.255 -157.457)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M413.519,163.524h.82l-.121.716h.494l-.107.669-.521-.015-.284,1.651,0,.059.014.05.03.038.039.032.053.021.059.018.065.012.071.006.065,0,.059-.006.054-.009.047-.012.039-.012.026-.009.018-.006.006,0-.1.55-.021.015-.021.012-.021.012-.021.012-.021.009-.024.009-.026.009-.027.009-.03.009-.03.006-.035.006-.035.006-.038.006-.045.006-.048.006-.05.006h-.225l-.118-.009-.1-.012-.094-.017-.08-.021-.069-.027-.056-.029-.05-.036-.038-.039-.03-.041-.021-.05-.014-.051-.009-.056,0-.062v-.065l.009-.068.009-.074.565-3.228Z",
    transform: "translate(-402.332 -156.434)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M413.519,163.524h.82l-.121.716h.494l-.107.669-.521-.015-.284,1.651h0l0,.059.014.05.03.038.039.032.053.021.059.018.065.012.071.006h0l.065,0,.059-.006.054-.009.047-.012.039-.012.026-.009.018-.006.006,0-.1.55h0l-.021.015-.021.012-.021.012-.021.012-.021.009-.024.009-.026.009-.027.009-.03.009-.03.006-.035.006-.035.006-.038.006-.045.006-.048.006-.05.006h-.225l-.118-.009-.1-.012-.094-.017-.08-.021-.069-.027-.056-.029-.05-.036-.038-.039-.03-.041-.021-.05-.014-.051-.009-.056,0-.062v-.065l.009-.068.009-.074.565-3.228",
    transform: "translate(-402.332 -156.434)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M417.816,167.047h0l-.009.05,0,.053.006.056.012.056.021.056.024.054.032.056.035.05.041.051.044.045.048.044.053.035.054.033.059.026.059.021.059.012h0l.077.012.074.009.077.009.077.006.077,0h.08l.077,0,.08-.006.08-.012.08-.015.083-.017.08-.027.083-.032.085-.036.083-.047.086-.05-.118.728h0l-.048.023-.047.024-.048.017-.044.018-.045.014-.048.015-.047.011-.05.009-.053.009-.059.006-.062.006-.068.006-.077,0h-.079l-.092,0h-.1l-.145,0-.148-.015-.148-.021-.148-.036-.145-.044-.139-.057-.134-.074-.124-.086-.115-.1-.1-.121-.086-.136-.072-.157-.05-.175-.032-.2-.009-.219.015-.242h0l.012-.095.017-.11.024-.115.032-.125.045-.127.053-.128.068-.13.083-.124.094-.119.115-.112.131-.1.148-.089.171-.074.193-.053.212-.035.24-.012h0l.115,0,.121.012.121.021.121.03.118.045.116.053.107.071.1.083.089.1.074.119.059.136.042.157.024.177,0,.2-.021.225-.045.249-.015.18h-2.157l.136-.583h1.3l.006-.074,0-.071-.006-.065-.011-.059-.021-.056-.021-.051-.03-.044-.03-.041-.035-.035-.039-.03-.044-.027-.045-.024-.047-.017-.047-.012-.05-.009-.053-.006h0l-.056,0-.053.009-.05.012-.05.017-.051.024-.044.027-.045.033-.038.035-.039.041-.036.044-.032.048-.027.051-.027.053-.021.059-.018.059-.012.062-.118.613",
    transform: "translate(-404.782 -157.457)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M432.548,164.208l-.038-.021-.038-.018-.042-.021-.044-.021-.045-.018-.049-.018-.051-.018-.053-.018-.056-.015-.057-.012-.061-.012-.062-.009-.068-.006-.068-.006H431.6l-.077.006-.08.009-.082.014-.083.024-.083.033-.083.041-.083.053-.08.065-.077.077-.074.095-.07.109-.065.13-.062.148-.056.166-.047.189-.019.106-.011.1-.006.1,0,.1.008.1.021.095.027.089.033.089.045.08.053.076.063.068.071.062.08.053.092.044.1.038.112.027.039.009.045.009.053.006.059.006.065.006h.142l.074-.006.077-.009.077-.014.074-.021.074-.023.074-.033.068-.038.062-.047.059-.053-.133.79-.018.015-.017.018-.024.021-.026.017-.033.024-.042.021-.048.021-.053.018-.068.021-.077.015-.089.012-.1.012-.115.006-.134,0-.15,0-.166-.009-.136-.015-.136-.03-.136-.044-.136-.059-.13-.071-.124-.089-.118-.1-.11-.118-.1-.133-.082-.148-.071-.166-.053-.181-.036-.2-.012-.21.006-.231.032-.246.024-.121.026-.118.03-.116.03-.109.032-.1.039-.1.039-.1.041-.092.045-.092.044-.086.05-.083.053-.077.054-.074.059-.071.059-.065.062-.062.068-.059.068-.056.071-.05.074-.047.08-.044.08-.038.083-.036.086-.033.092-.03.091-.024.095-.021.1-.017.1-.015.107-.012.107-.006.113,0,.1,0,.091.006.089.009.089.012.083.011.08.018.077.015.071.018.068.018.059.018.056.018.047.018.042.015.035.012.027.012.018.006-.149.819Z",
    transform: "translate(-412.457 -156.225)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M432.548,164.208h0l-.038-.021-.038-.018-.042-.021-.044-.021-.045-.018-.049-.018-.051-.018-.053-.018-.056-.015-.057-.012-.061-.012-.062-.009-.068-.006-.068-.006H431.6l-.077.006-.08.009-.082.014-.083.024-.083.033-.083.041-.083.053-.08.065-.077.077-.074.095-.07.109-.065.13-.062.148-.056.166-.047.189h0l-.019.106-.011.1-.006.1,0,.1.008.1.021.095.027.089.033.089.045.08.053.076.063.068.071.062.08.053.092.044.1.038.112.027h0l.039.009.045.009.053.006.059.006.065.006h.142l.074-.006.077-.009.077-.014.074-.021.074-.023.074-.033.068-.038.062-.047.059-.053-.133.79h0l-.018.015-.017.018-.024.021-.026.017-.033.024-.042.021-.048.021-.053.018-.068.021-.077.015-.089.012-.1.012-.115.006-.134,0-.15,0-.166-.009h0l-.136-.015-.136-.03-.136-.044-.136-.059-.13-.071-.124-.089-.118-.1-.11-.118-.1-.133-.082-.148-.071-.166-.053-.181-.036-.2-.012-.21.006-.231.032-.246h0l.024-.121.026-.118.03-.116.03-.109.032-.1.039-.1.039-.1.041-.092.045-.092.044-.086.05-.083.053-.077.054-.074.059-.071.059-.065.062-.062.068-.059.068-.056.071-.05.074-.047.08-.044.08-.038.083-.036.086-.033.092-.03.091-.024.095-.021.1-.017.1-.015.107-.012.107-.006.113,0h0l.1,0,.091.006.089.009.089.012.083.011.08.018.077.015.071.018.068.018.059.018.056.018.047.018.042.015.035.012.027.012.018.006-.149.819",
    transform: "translate(-412.457 -156.225)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M451.718,167.432h-.82l.059-.328v-.03l-.048.06-.05.053-.05.047-.053.042-.053.038-.053.032-.053.027-.056.027-.056.021-.056.015-.056.015-.059.009-.059.009-.056.006-.059,0h-.059l-.154-.012-.142-.033-.13-.05-.119-.068-.106-.086-.095-.1-.083-.11-.071-.124-.059-.134-.048-.139-.033-.145-.024-.151-.009-.151,0-.154.015-.151.027-.151.044-.175.053-.165.062-.151.074-.142.077-.133.089-.119.091-.106.1-.1.1-.086.109-.074.113-.065.113-.05.118-.042.118-.026.118-.018.121-.006.086,0,.083.009.077.015.071.021.068.024.059.026.059.033.053.033.047.035.044.039.039.038.036.038.03.038.027.038.024.036.017.035h0l.208-1.163h.8l-.669,3.87Z",
    transform: "translate(-424.342 -156.457)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M451.718,167.432h-.82l.059-.328v-.03h0l-.048.06-.05.053-.05.047-.053.042-.053.038-.053.032-.053.027-.056.027-.056.021-.056.015-.056.015-.059.009-.059.009-.056.006-.059,0h-.059l-.154-.012-.142-.033-.13-.05-.119-.068-.106-.086-.095-.1-.083-.11-.071-.124-.059-.134-.048-.139-.033-.145-.024-.151-.009-.151,0-.154.015-.151.027-.151h0l.044-.175.053-.165.062-.151.074-.142.077-.133.089-.119.091-.106.1-.1.1-.086.109-.074.113-.065.113-.05.118-.042.118-.026.118-.018.121-.006h0l.086,0,.083.009.077.015.071.021.068.024.059.026.059.033.053.033.047.035.044.039.039.038.036.038.03.038.027.038.024.036.017.035h0l.208-1.163h.8l-.669,3.87",
    transform: "translate(-424.342 -156.457)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M451.869,168.93l.083-.006.077-.018.071-.021.068-.033.062-.035.059-.045.056-.05.05-.054.044-.059.042-.065.038-.068.033-.071.029-.074.024-.077.02-.08.015-.08.014-.083.009-.086v-.081l0-.082-.009-.077-.012-.074-.021-.071-.024-.068-.029-.059-.036-.057-.038-.048-.045-.041-.05-.035-.053-.024-.056-.015-.062-.006-.08.006-.074.012-.068.024-.068.03-.059.039-.059.047-.05.05-.05.056-.044.065-.042.068-.039.071-.032.077-.029.08-.023.081-.024.085-.018.086-.015.13.006.142.02.145.039.139.059.122.077.1.1.065.118.024Z",
    transform: "translate(-425.833 -158.671)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M401.688,167.812l-.119.657h-.746l.021-.121.015-.109.011-.083.012-.045-.041.047-.048.048-.056.044-.062.041-.071.042-.074.035-.077.036-.08.03-.086.026-.085.021-.086.018-.088.012-.086.006-.085,0-.083-.009-.08-.012-.1-.027-.095-.03-.083-.038-.074-.044-.065-.047-.059-.053-.048-.057-.041-.059-.035-.062-.03-.065-.023-.064-.018-.065-.012-.068-.009-.068-.006-.065v-.065L399,167.5l.018-.109.03-.1.039-.1.047-.095.053-.086.062-.083.071-.074.074-.068.083-.062.086-.056.088-.048.095-.041.1-.033.1-.026.1-.018h.006l.015,0,.021,0,.032,0,.036-.006.041,0,.044-.006.051-.006.05-.006.051-.006.053,0,.047-.006.048,0,.044,0,.042,0h.1l.071,0,.065,0h.065l.053,0,.042,0,.029,0h.009l.006-.021.018-.053.014-.062.006-.056-.012-.065-.026-.06-.036-.053-.048-.045L400.93,166l-.062-.027-.071-.018-.077-.006-.083,0-.089,0h-.092l-.094,0-.1.006-.095.009-.094.009-.092.012-.089.012-.086.015-.077.014-.071.015-.065.018-.054.017-.041.021-.033.018.21-.713.065-.027.065-.024.071-.021.071-.015.072-.015.077-.011.077-.012.08-.006.083-.006.086,0,.089,0h.284l.1,0,.1,0,.083.006.089.015.091.021.095.027.092.036.089.041.089.05.084.056.073.065.066.071.059.08.044.089.03.1.017.1v.112l-.017.118-.3,1.562Z",
    transform: "translate(-393.823 -157.494)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M401.688,167.812l-.119.657h-.746l.021-.121.015-.109.011-.083.012-.045h0l-.041.047-.048.048-.056.044-.062.041-.071.042-.074.035-.077.036-.08.03-.086.026-.085.021-.086.018-.088.012-.086.006-.085,0-.083-.009-.08-.012h0l-.1-.027-.095-.03-.083-.038-.074-.044-.065-.047-.059-.053-.048-.057-.041-.059-.035-.062-.03-.065-.023-.064-.018-.065-.012-.068-.009-.068-.006-.065v-.065h0L399,167.5l.018-.109.03-.1.039-.1.047-.095.053-.086.062-.083.071-.074.074-.068.083-.062.086-.056.088-.048.095-.041.1-.033.1-.026.1-.018h.006l.015,0,.021,0,.032,0,.036-.006.041,0,.044-.006.051-.006.05-.006.051-.006.053,0,.047-.006.048,0,.044,0,.042,0h.1l.071,0,.065,0h.065l.053,0,.042,0,.029,0h.009l.006-.021.018-.053.014-.062.006-.056h0l-.012-.065-.026-.06-.036-.053-.048-.045L400.93,166l-.062-.027-.071-.018-.077-.006h0l-.083,0-.089,0h-.092l-.094,0-.1.006-.095.009-.094.009-.092.012-.089.012-.086.015-.077.014-.071.015-.065.018-.054.017-.041.021-.033.018.21-.713h0l.065-.027.065-.024.071-.021.071-.015.072-.015.077-.011.077-.012.08-.006.083-.006.086,0,.089,0h.284l.1,0,.1,0h0l.083.006.089.015.091.021.095.027.092.036.089.041.089.05.084.056.073.065.066.071.059.08.044.089.03.1.017.1v.112l-.017.118-.3,1.562",
    transform: "translate(-393.823 -157.494)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M402.416,169.74l0-.015-.012-.015-.018-.009-.029-.006-.033-.006-.038,0h-.089l-.047,0-.05.006-.047.006-.048.006-.044.006-.042.009-.035.009-.033.009-.02.006-.024.009-.033.012-.033.015-.038.018-.038.021-.041.02-.038.024-.041.03-.039.029-.036.036-.032.036-.03.038-.021.042-.017.047-.009.047,0,.1.014.08.03.059.038.044.044.03.051.018.047.009.047,0,.088,0,.08-.009.077-.012.068-.018.059-.021.056-.026.05-.027.045-.033.038-.03.035-.035.03-.032.024-.036.02-.036.019-.035.014-.033.008-.033.024-.085.021-.1.018-.094.015-.077Z",
    transform: "translate(-395.264 -160.194)",
    fill: "#ec1c2e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M388.676,167.409h-.8l.672-3.885h1.4l.134,2.3.968-2.3h1.462l-.687,3.885h-.8l.509-2.9h-.032l-1.2,2.9h-.908l-.006-.121-.021-.323-.026-.458-.03-.527-.03-.529-.026-.464-.021-.337-.006-.142h-.044l-.492,2.9Z",
    transform: "translate(-387.037 -156.434)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M388.676,167.409h-.8l.672-3.885h1.4l.134,2.3.968-2.3h1.462l-.687,3.885h-.8l.509-2.9h-.032l-1.2,2.9h-.908l-.006-.121-.021-.323-.026-.458-.03-.527-.03-.529-.026-.464-.021-.337-.006-.142h-.044l-.492,2.9",
    transform: "translate(-387.037 -156.434)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M439.384,167.812l-.122.657h-.743l.006-.121,0-.106v-.08l.006-.035-.038.044-.045.044-.053.041-.059.042-.062.038-.071.035-.074.036-.074.029-.08.023-.083.024-.082.015-.083.012-.086.006-.082,0-.08-.009-.08-.012-.106-.027-.094-.03-.083-.038-.077-.044-.065-.047-.056-.053-.047-.057-.041-.059-.036-.062-.027-.065-.024-.064-.015-.065-.013-.068-.008-.068-.007-.065v-.065l.007-.116.018-.109.026-.1.039-.1.044-.095.056-.086.062-.083.068-.074.077-.068.08-.062.086-.056.092-.048.092-.041.1-.033.1-.026.1-.018h.006l.014,0,.021,0,.03,0,.039-.006.041,0,.045-.006.047-.006.051-.006.053-.006.05,0,.05-.006.047,0,.041,0,.042,0h.1l.071,0,.068,0h.065l.056,0,.047,0,.026,0h.012l.006-.021.009-.053.009-.062.006-.056-.011-.065-.023-.06-.038-.053-.045-.045-.053-.038-.062-.027-.065-.018-.071-.006-.083,0-.088,0h-.092l-.095,0-.1.006-.1.009-.095.009-.092.012L437.6,166l-.085.015-.077.014-.071.015-.065.018-.053.017-.042.021-.032.018.207-.713.065-.027.069-.024.068-.021.071-.015.074-.015.074-.011.076-.012.081-.006.082-.006.086,0,.086,0h.278l.1,0,.1,0,.083.006.089.015.092.021.095.027.092.036.091.041.089.05.083.056.074.065.068.071.059.08.045.089.033.1.021.1v.112l-.015.118-.31,1.562Z",
    transform: "translate(-416.833 -157.494)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M443.242,172.478l.017-.018.121-.657-.036-.006-.121.657.018-.018v.042l.014,0,0-.015-.017.018Z",
    transform: "translate(-420.812 -161.482)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M441.314,173.457l.018.021h.743v-.042h-.743l.018.021h-.036l0,.021h.021l-.018-.021Z",
    transform: "translate(-419.646 -162.482)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M441.366,172.6l-.027-.023-.012.048,0,.08v.106l-.005.121h.036l.006-.121.006-.106,0-.08V172.6l-.027-.023.03.023Z",
    transform: "translate(-419.65 -161.959)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M438.487,172.982h0l.083.012.08.009.082,0,.086-.006.085-.012.083-.015.083-.023.082-.024.074-.03.077-.035.072-.035.061-.041.062-.042.053-.041.048-.048.039-.045-.03-.023-.038.044-.042.041-.053.042-.056.041-.062.035-.071.036-.071.035-.074.029-.077.024-.083.024-.083.015-.079.011-.086.006-.082,0-.08-.009-.077-.011h0l-.006.035Z",
    transform: "translate(-417.922 -161.959)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M436.65,171.311h0l0,.065.006.065.009.071.012.068.015.065.024.068.026.068.039.062.041.062.048.056.059.056.068.047.077.048.086.038.1.03.107.027.006-.035-.107-.027-.092-.03-.08-.038-.077-.042-.062-.047-.053-.051-.047-.056-.042-.056-.032-.062-.026-.062-.024-.062-.014-.065-.012-.068-.009-.065-.006-.065,0-.065h-.041Z",
    transform: "translate(-416.801 -161.185)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M437.712,168.4h0l-.1.018-.1.027-.1.032-.094.041-.092.047-.088.059-.08.062-.077.071-.071.074-.062.083-.059.089-.044.1-.038.1-.027.106-.018.112-.009.116h.041l0-.116.018-.106.027-.1.038-.1.044-.092.053-.083.063-.083.065-.074.077-.065.08-.062.082-.053.093-.048.088-.041.1-.033.095-.027.1-.018h0V168.4Z",
    transform: "translate(-416.801 -159.407)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M439.984,168.237h-.032l-.042.006-.041,0-.047,0-.05.006-.05,0-.053.006-.051.006-.047.006-.045.006-.041,0-.039.006-.03,0-.024,0-.012,0h-.006v.036h.006l.018,0,.018,0,.03,0,.039-.006.041,0,.045-.006.047-.006.051-.006.053-.006.05,0,.05-.006.047,0,.041,0h.074v-.042Z",
    transform: "translate(-418.464 -159.31)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M441.338,168.269l.018-.015h-.012l-.026,0-.047,0-.056-.006h-.133l-.071-.006h-.071v.042h.142l.068.006h.121l.047,0,.026,0h.012l.018-.015-.018.015.015,0,0-.017-.036-.006Z",
    transform: "translate(-419.418 -159.31)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M441.994,167.835h0l0,.056-.009.059-.009.053-.006.021.036.006.006-.021.009-.054.009-.065.009-.056h-.038Z",
    transform: "translate(-420.044 -159.064)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M441.136,167.024v0l.069,0,.062.018.059.026.05.036.041.041.036.05.024.053.012.062h.035l-.012-.068-.023-.065-.042-.056-.047-.048-.056-.041-.065-.027-.068-.017-.074-.009v.038Z",
    transform: "translate(-419.538 -158.546)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M437.88,167.156l.03.018.029-.015.038-.021.051-.018.065-.017.072-.015.076-.015.086-.015.086-.011.092-.013.095-.009.095-.009.1-.006h.275l.083,0v-.036l-.083,0-.088-.006h-.092l-.095.006-.1.005-.095.009L438.5,167l-.092.012-.092.011-.086.015-.077.015-.071.015-.065.017-.056.018-.044.02-.035.021.03.018-.036-.006Z",
    transform: "translate(-417.552 -158.536)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M438.1,165.58l-.012.015-.207.713.036.006.207-.713-.012.015-.011-.036-.009,0,0,.012.012-.015Z",
    transform: "translate(-417.552 -157.689)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M439.759,165.218h0l-.1-.006-.1,0h-.278l-.086.006-.086,0-.082.006-.08.005-.08.012-.073.012-.074.015-.072.015-.071.021-.068.024-.065.026.011.036.065-.027.068-.023.065-.021.071-.014.074-.015.073-.012.074-.012.08-.006.082-.006.086,0h.364l.1,0h.1v-.035Z",
    transform: "translate(-417.895 -157.462)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M442.834,166.235h0l.015-.121V166l-.02-.1-.033-.1-.047-.091-.06-.083-.071-.074-.074-.065-.086-.057-.089-.053-.095-.041-.092-.036-.1-.026-.092-.021-.091-.014-.083-.006v.035l.083.006.086.015.092.021.091.027.092.035.089.042.089.047.08.056.074.065.065.068.059.076.041.087.033.092.021.1v.112l-.015.116h0l.036.006Z",
    transform: "translate(-419.956 -157.476)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M443.57,169.358h0l.311-1.562-.036-.006-.311,1.562h0l.036.006Z",
    transform: "translate(-421.002 -159.037)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M440.109,169.735l-.006-.018-.011-.014-.021-.009-.03-.009-.033,0-.039,0h-.045l-.044,0-.047.006-.047.006-.047.006-.045.006-.043.009-.039.006-.039.009-.029.006-.02,0-.024.009-.029.009-.033.012-.039.017-.035.018-.042.021-.038.026-.039.027-.039.033-.032.032-.033.039-.027.041-.021.044-.017.048-.009.05,0,.1.014.08.025.059.035.044.044.03.051.018.05.009.05,0,.089,0,.082-.009.077-.015.069-.02.065-.024.056-.026.053-.03.047-.035.042-.033.035-.038.033-.036.027-.039.02-.035.015-.036.012-.035.009-.033.012-.083.015-.086.011-.083.006-.074Z",
    transform: "translate(-418.275 -160.189)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M457.379,171.825l.007-.069.023-.08.042-.071.05-.062.062-.05.071-.036.077-.024.082-.009.083.009.077.024.071.036.062.05.05.062.041.071.023.08.006.069h-.089l0-.054-.018-.065-.029-.059-.038-.051-.047-.041-.056-.029-.065-.021-.068-.006-.068.006-.065.021-.056.029-.048.041-.038.051-.029.059-.018.065-.006.054Z",
    transform: "translate(-429.45 -161.255)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M458.063,172.173V172h.163l.036,0,.033.006.023.009.021.012.015.018.012.018.006.02,0,.021,0,.026-.006.021-.009.018-.006.006h-.124l.012,0,.021,0,.018-.006.015-.006.012-.009.006-.009.005-.014V172.1l0-.015-.006-.012-.008-.006-.009-.006-.015,0-.015,0h-.121v.115Z",
    transform: "translate(-429.868 -161.603)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M457.376,172.451l0,.017.009.086.023.08.042.071.05.059.062.05.071.039.077.023.082.009.083-.009.077-.023.071-.039.062-.05.05-.059.041-.071.023-.08.009-.086,0-.017h-.089l0,.017-.006.071-.018.065-.03.056-.038.05-.047.042-.056.032-.065.021-.068.006-.068-.006-.065-.021-.056-.032-.048-.042-.038-.05-.029-.056-.018-.065-.006-.071v-.017Z",
    transform: "translate(-429.447 -161.881)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M458.063,172.451v.18h.074v-.148h.074l.088.148h.06l-.089-.148h.021l.02-.006.018-.006.015-.012.006-.009h-.124l-.015,0h-.074v0Z",
    transform: "translate(-429.868 -161.881)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M457.373,171.842h0l.009-.086.023-.08.042-.071.05-.062.062-.05.071-.036.077-.024.083-.009h0l.083.009.077.024.071.036.062.05.05.062.041.071.023.08.009.086h0l-.009.086-.023.08-.041.071-.05.059-.062.05-.071.039-.077.023-.083.009h0l-.083-.009-.077-.023-.071-.039-.062-.05-.05-.059-.042-.071-.023-.08-.009-.086m.343.163h-.074v-.358h.163l.036,0,.032.006.023.009.021.012.015.018.012.018.006.02,0,.021h0l0,.027-.006.021-.009.018-.012.015-.015.012-.018.006-.021.006h-.021l.089.148h-.06l-.089-.148h-.074v.148m.074-.178h0l.026-.006.021,0,.018-.006.015-.006.012-.009.006-.009.005-.014v-.021h0l0-.015-.006-.012-.008-.005-.009-.006-.015,0-.014,0h-.121v.118h.074m0,.358h0l.068-.006.065-.021.057-.032.047-.042.039-.049.03-.057.018-.065.006-.071h0l-.006-.071-.018-.065-.03-.059-.039-.051-.047-.041-.057-.029-.065-.021-.068-.006h0l-.068.006-.065.021-.056.029-.048.041-.038.051-.029.059-.018.065-.006.071h0l.006.071.018.065.029.057.038.049.048.042.056.032.065.021.068.006",
    transform: "translate(-429.446 -161.255)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M444.151,168.478h.835l.3-1.684.012-.065.018-.065.018-.065.024-.065.029-.065.035-.062.039-.059.047-.056.053-.05.059-.048.068-.045.077-.035.086-.029.095-.024.1-.018.115-.006h.074l.133-.76-.083.006-.08.009-.074.014-.071.021-.065.024-.062.03-.059.032-.056.035-.053.042-.051.041-.047.048-.047.047-.045.05-.044.056-.044.053-.041.059.089-.535H444.7l-.553,3.169Z",
    transform: "translate(-421.378 -157.504)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M444.151,168.478h.835l.3-1.684h0l.012-.065.018-.065.018-.065.024-.065.029-.065.035-.062.039-.059.047-.056.053-.05.059-.048.068-.045.077-.035.086-.029.095-.024.1-.018.115-.006h.074l.133-.76h0l-.083.006-.08.009-.074.014-.071.021-.065.024-.062.03-.059.032-.056.035-.053.042-.051.041-.047.048-.047.047-.045.05-.044.056-.044.053-.041.059.089-.535H444.7l-.553,3.169h0",
    transform: "translate(-421.378 -157.504)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M424.05,168.478h.849l.284-1.684.012-.065.015-.062.015-.062.021-.059.023-.059.03-.056.035-.053.041-.05.047-.045.053-.044.065-.036.071-.032.083-.027.092-.023.1-.015L426,166.1h.009l.012,0,.015,0h.015l.015,0,.012,0,.008,0h0l0-.012.009-.036.012-.053.015-.065.02-.077.021-.083.027-.083.026-.083.024-.056.03-.057.029-.056.03-.05.026-.044.021-.036.015-.021.006-.009h0l-.012,0-.014,0-.021,0h-.02l-.024,0-.021,0h-.021l-.092.006-.083.009-.077.014-.071.018-.068.023-.062.03-.056.029-.053.035-.05.039-.048.044-.044.045-.044.05-.045.051-.041.057-.044.059-.045.059.106-.535H424.6l-.553,3.169Z",
    transform: "translate(-409.113 -157.504)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M424.05,168.478h.849l.284-1.684h0l.012-.065.015-.062.015-.062.021-.059.023-.059.03-.056.035-.053.041-.05.047-.045.053-.044.065-.036.071-.032.083-.027.092-.023.1-.015L426,166.1h.009l.012,0,.015,0h.015l.015,0,.012,0,.008,0h0l0-.012.009-.036.012-.053.015-.065.02-.077.021-.083.027-.083.026-.083h0l.024-.056.03-.057.029-.056.03-.05.026-.044.021-.036.015-.021.006-.009h0l-.012,0-.014,0-.021,0h-.02l-.024,0-.021,0h-.021l-.092.006-.083.009-.077.014-.071.018-.068.023-.062.03-.056.029-.053.035-.05.039-.048.044-.044.045-.044.05-.045.051-.041.057-.044.059-.045.059.106-.535H424.6l-.553,3.169h0",
    transform: "translate(-409.113 -157.504)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.216
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M457.4,180.961v-.012l.023-.077.042-.068.05-.059.062-.047.071-.036.077-.02.082-.009.083.009.077.02.071.036.062.047.05.059.041.068.023.077v.012h-.085l-.018-.062-.03-.057-.038-.051-.047-.041-.056-.033-.065-.021-.068-.006-.068.006-.065.021-.056.033-.048.041-.038.051-.029.057-.018.062Z",
    transform: "translate(-429.461 -166.874)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M458.063,181.314v-.1h.2l.033.006.023.005.021.012.015.015.012.018.006.021,0,.027h-.059V181.3l0-.015-.006-.012-.008-.006-.009-.006-.015,0-.015,0h-.121v.059Z",
    transform: "translate(-429.868 -167.226)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M457.373,181.54l.009-.065h.085v0l-.006.062Z",
    transform: "translate(-429.447 -167.388)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M458.063,181.54v-.065h.074v.059h.074l.026-.006.021,0,.018-.006.015-.006.012-.009.006-.009.005-.014v-.006h.059l0,.021-.006.018-.009.015-.012.011Z",
    transform: "translate(-429.868 -167.388)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M459.277,181.54l-.006-.062v0h.085l.009.065Z",
    transform: "translate(-430.605 -167.388)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M457.373,181.642v.009l.009.086.023.08.042.071.05.062.062.051.071.035.077.024.082.009.083-.009.077-.024.071-.035.062-.051.05-.062.041-.071.023-.08.009-.086v-.009h-.088v.009l-.006.071-.018.065-.03.056-.038.05-.047.042-.056.032-.065.021-.068.006-.068-.006-.065-.021-.056-.032-.048-.042-.038-.05-.029-.056-.018-.065-.006-.071v-.009Z",
    transform: "translate(-429.447 -167.489)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M458.063,181.642v.172h.074v-.148h.074l.088.148h.06l-.089-.148h.021l.02-.005.018-.006.015-.012h-.281Z",
    transform: "translate(-429.868 -167.489)",
    fill: "#fbb231",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M419.81,166.206l-.024-.177-.042-.157-.059-.136-.074-.119-.088-.1-.1-.083-.107-.071-.116-.053-.118-.045-.122-.029-.121-.021-.122-.012-.115,0-.24.012-.212.035-.193.053-.172.074-.148.089-.131.1-.115.112-.094.118-.083.124-.068.13-.053.128-.045.126-.032.125-.024.115-.017.11-.012.095-.015.242.009.219.032.2.05.175.072.157.086.136.1.121.115.1.124.086.134.074.139.056.145.044.148.036.149.021.147.015.145,0h.1l.092,0h.08l.077,0,.068-.006.062-.006.059-.006.053-.009.05-.009.047-.011.048-.015.044-.014.044-.018.048-.017.047-.024.048-.024.118-.728-.085.05-.083.047-.085.036-.083.032-.08.027-.083.018-.08.015-.08.012-.08.006-.077,0h-.08l-.077,0-.077-.006-.077-.009-.074-.009-.077-.012-.059-.012-.059-.021-.059-.026-.053-.033-.053-.035-.048-.044-.044-.045-.041-.051-.035-.05-.032-.056-.024-.054-.021-.057-.012-.056-.005-.057,0-.05.007-.038h1.919l.015-.18.045-.249.021-.225Zm-.8.272h-1.081v0h0l.008-.041.012-.062.018-.059.021-.059.026-.053.027-.051.032-.048.035-.044.039-.041.038-.035.045-.032.044-.027.051-.024.05-.017.05-.012.053-.009.056,0,.053.006.05.009.048.012.047.017.044.024.044.027.039.03.035.035.029.041.03.044.021.051.021.057.011.059.006.065,0,.071Z",
    transform: "translate(-404.782 -157.457)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(679 287.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2029",
    "data-name": "Rectangle 2029",
    d: "M4.181,0H44.713a4.181,4.181,0,0,1,4.181,4.181v22.2a4.182,4.182,0,0,1-4.182,4.182H4.181A4.181,4.181,0,0,1,0,26.378V4.181A4.181,4.181,0,0,1,4.181,0Z",
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M395.092,525.168h33.824a1.63,1.63,0,0,0,1.63-1.63V512.1C427.3,514.154,415.06,521.249,395.092,525.168Z",
    transform: "translate(-381.652 -494.609)",
    fill: "#f58220"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513",
    transform: "translate(9.881 12.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M421.041,500.328a2.4,2.4,0,0,0-2.439,2.351,2.438,2.438,0,1,0,2.439-2.351Z",
    transform: "translate(-405.878 -500.31)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M387.272,500.547h-1.311v4.576h1.305a2.391,2.391,0,0,0,1.632-.527,2.306,2.306,0,0,0,.83-1.758A2.273,2.273,0,0,0,387.272,500.547Zm1.044,3.437a1.69,1.69,0,0,1-1.222.364h-.24v-3.026h.24a1.657,1.657,0,0,1,1.222.37,1.537,1.537,0,0,1,.492,1.138A1.565,1.565,0,0,1,388.316,503.984Z",
    transform: "translate(-385.961 -500.444)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    width: 0.892,
    height: 4.576,
    transform: "translate(4.179 0.103)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M401.679,502.183c-.536-.2-.693-.329-.693-.576,0-.288.28-.507.665-.507a.928.928,0,0,1,.721.369l.466-.609a2,2,0,0,0-1.345-.508,1.344,1.344,0,0,0-1.427,1.31c0,.632.288.954,1.125,1.256a3.514,3.514,0,0,1,.617.261.549.549,0,0,1,.268.473.652.652,0,0,1-.694.645,1.054,1.054,0,0,1-.974-.61l-.575.557a1.779,1.779,0,0,0,1.585.871,1.476,1.476,0,0,0,1.578-1.5C403,502.884,402.7,502.554,401.679,502.183Z",
    transform: "translate(-394.426 -500.325)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M408.667,502.676a2.37,2.37,0,0,0,2.415,2.388,2.458,2.458,0,0,0,1.119-.267v-1.05a1.429,1.429,0,0,1-1.078.5,1.5,1.5,0,0,1-1.537-1.578,1.521,1.521,0,0,1,1.5-1.571,1.5,1.5,0,0,1,1.119.515v-1.05a2.276,2.276,0,0,0-1.1-.28A2.406,2.406,0,0,0,408.667,502.676Z",
    transform: "translate(-399.816 -500.283)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M432.846,503.62l-1.222-3.074h-.974l1.942,4.693h.48l1.976-4.693h-.967Z",
    transform: "translate(-413.23 -500.444)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M442.974,505.123h2.532v-.775h-1.64v-1.236h1.577v-.774h-1.577v-1.016h1.64v-.775h-2.532Z",
    transform: "translate(-420.75 -500.444)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M453.922,501.9c0-.857-.589-1.351-1.619-1.351h-1.325v4.576h.893v-1.839h.117l1.234,1.839h1.1l-1.442-1.928A1.217,1.217,0,0,0,453.922,501.9Zm-1.791.755h-.26v-1.386h.274c.556,0,.859.234.859.679C453,502.406,452.7,502.653,452.131,502.653Z",
    transform: "translate(-425.634 -500.444)",
    fill: "#001722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M459.7,501.227c0-.08-.053-.124-.152-.124h-.13v.4h.1v-.157l.113.157h.12l-.135-.167A.111.111,0,0,0,459.7,501.227Zm-.168.055h-.018v-.1h.019c.047,0,.071.017.071.051S459.583,501.282,459.535,501.282Z",
    transform: "translate(-430.786 -500.783)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M459.254,500.715a.352.352,0,1,0,.348.352A.35.35,0,0,0,459.254,500.715Zm0,.641a.289.289,0,1,1,.277-.288A.284.284,0,0,1,459.254,501.356Z",
    transform: "translate(-430.469 -500.547)",
    fill: "#231f20"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.0303cf8f10491627d0a6731db01880e4.svg";
export { ForwardRef as ReactComponent };